import { render, staticRenderFns } from "./AboutUpmPdf.vue?vue&type=template&id=e5255ea8&scoped=true&"
import script from "./AboutUpmPdf.vue?vue&type=script&lang=js&"
export * from "./AboutUpmPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5255ea8",
  null
  
)

export default component.exports